module.exports = "/images/ug.svg?ebf99ddf6d4ca68050cd7c7a8b255871";